<template>
    <DModal :data-test-id="dataTestId" @close="close">
        <DVideo
            class="d-video-modal-content"
            :src="src"
            :title="title"
            :autoplay="autoplay"
            :controls="controls"
            :data-test-id="`${dataTestId}-video`"
        />
    </DModal>
</template>

<script lang="ts" setup>
    import DModal from "../molecules/DModal.vue";
    import DVideo from "../atoms/DVideo.vue";

    withDefaults(
        defineProps<{
            src: string;
            title: string;
            autoplay?: boolean;
            controls?: boolean;
            dataTestId?: string;
        }>(),
        {
            autoplay: true,
            controls: true,
            dataTestId: "DVideoModal",
        },
    );

    const emit = defineEmits(["close"]);

    const close = () => {
        emit("close");
    };
</script>

<style lang="scss" scoped>
.d-video-modal-content {
  position: relative; 
  width: 100%;
  overflow: hidden;
  margin-top: 2rem;

  @include md { 
    margin-top: 0;
    height: 500px;
  }
}
</style>
